var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOptions(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7539 4.91218C13.7539 3.83148 12.8697 2.94727 11.789 2.94727C10.7083 2.94727 9.82408 3.83148 9.82408 4.91218C9.82408 5.99288 10.7083 6.87709 11.789 6.87709C12.8697 6.87709 13.7539 5.99288 13.7539 4.91218Z",
    stroke: "#2B292D",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7539 18.6666C13.7539 17.5859 12.8697 16.7017 11.789 16.7017C10.7083 16.7017 9.82408 17.5859 9.82408 18.6666C9.82408 19.7473 10.7083 20.6315 11.789 20.6315C12.8697 20.6315 13.7539 19.7473 13.7539 18.6666Z",
    stroke: "#2B292D",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7539 11.7896C13.7539 10.7089 12.8697 9.82471 11.789 9.82471C10.7083 9.82471 9.82408 10.7089 9.82408 11.7896C9.82408 12.8703 10.7083 13.7545 11.789 13.7545C12.8697 13.7545 13.7539 12.8703 13.7539 11.7896Z",
    stroke: "#2B292D",
    strokeWidth: 1.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptions);
export default __webpack_public_path__ + "static/media/options.ad528b03881dbc3128fd5af7cd335683.svg";
export { ForwardRef as ReactComponent };